// SPDX-License-Identifier: LicenseRef-MMS-WIRE
// Copyright (c) 2016-2026 Metal Management Solutions (Pty) Ltd

import { enableProdMode, mergeApplicationConfig } from '@angular/core';
import { environment } from './app/environments/environment';
import { bootstrapApplication } from "@angular/platform-browser";
import { AppComponent } from "./app/app.component";
import { appConfig } from "./app/app.config";
import { provideKeycloakAngular } from "./app/factories/keycloak-init.factory";

if (environment.production) {
    enableProdMode();
}

bootstrapApplication(AppComponent, mergeApplicationConfig(appConfig, {
    providers: [provideKeycloakAngular()]
})).catch(err => console.error(err));
